<template lang="pug">
ContainerComponent(:bread-crumb-path="breadCrumbPath" header-text="Informações do usuário")
  v-row(:justify="isMobile ? 'center' : 'start'" no-gutters)
    v-col(cols=10 md=12 lg=8)
      v-card.details-account(color="rgba(180, 180, 180, 0.15)")
        v-card-title.pb-6
          h3 Detalhes da Conta
        v-card-text.details-account-text
          template(v-if="isMobile")
            v-row
              v-col(cols=12)
                h4 Nome
                span {{ user.name }}
              v-col(cols=12)
                h4 Login
                span {{ user.username }}
              v-col(cols=12)
                h4 Perfil
                span {{ user.group }}
              v-col(cols=12)
                h4 Email
                span {{ user.email }}
              v-col(v-if="user.segmentation" cols=12)
                h4 Segmentação
                span {{ user.segmentation }}
              v-col(v-if="user.nmMunicipio" cols=12)
                h4 Município
                span {{ user.nmMunicipio }}
          template(v-else)
            v-row.pb-2(no-gutters)
              v-col(cols=5)
                h4 Nome
              v-col(cols=5)
                h4 Perfil
            v-row(no-gutters)
              v-col(cols=5)
                span {{ user.name }}
              v-col(cols=5)
                span {{ user.group }}
            v-row.pb-2.pt-2(no-gutters)
              v-col(cols=5)
                h4 Email
              v-col(cols=5)
                h4 Login
            v-row(no-gutters)
              v-col(cols=5)
                span {{ user.email }}
              v-col(cols=5)
                span {{ user.username }}
            v-row.pb-2.pt-2(no-gutters)
              v-col(v-if="user.segmentation" cols=5)
                h4 Segmentação
              v-col(v-if="user.nmMunicipio" cols=5)
                h4 Município
            v-row(no-gutters)
              v-col(v-if="user.segmentation" cols=5)
                span {{ user.segmentation }}
              v-col(v-if="user.nmMunicipio" cols=5)
                span {{ user.nmMunicipio }}
</template>

<script>
import { mapFields } from "vuex-map-fields";
import Breakpoints from "@/mixins/utils/Breakpoints.js";
export default {
  name: "MyProfileView",
  components: {
    ContainerComponent: () =>
      import("@/components/heading/ContainerComponent.vue"),
  },
  mixins: [Breakpoints],
  data() {
    return {
      breadCrumbPath: [
        { text: "Home", disabled: false, to: "/" },
        { text: "Informações do Usuário", disabled: true },
      ],
    };
  },
  computed: {
    ...mapFields("auth", ["user"]),
  },
};
</script>

<style lang="sass">
.details-account
  margin-top: 24px

.details-account-text
  padding: 16px

h3
  font-family: 'Poppins'
  font-style: normal
  font-weight: 500
  font-size: 18px
  line-height: 120%

h4
  font-family: 'Poppins'
  font-style: normal
  font-weight: 400
  font-size: 14px
  line-height: 120%
  color: var(--v-myProfileText-base)
</style>
